import React, { useContext, useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import Contact from "../../ext/Contact";
import SharedDataContext from "../../../SharedDataContext";

import Highlights from "../../ext/Highlights";
import Persona from "../../ext/Persona";
import { ChevronLeft } from "lucide-react";
import CRM from "../../ext/crm";
import { useMutation } from "react-query";
import ProfileInfo from "../../ext/ProfileInfo";
import CompanyInfo from "../../ext/CompanyInfo";
import Header from "../../ext/Header";
import NoCompany from "../../ext/error/NoCompany";
import Onboarding from "../../ext/Onboarding";
import MessageDrafter from "../../ext/MessageDrafter";
import { Skeleton } from "../../ui/skeleton";
import { getSavedCRMConfig } from "../../../apis/ext";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import { useStoreIntegrations } from "../../../stores/useStoreIntegrations";
import { useIntegrations } from "../../../apiHooks/useIntegrations";
import { useStoreCRMConfig } from "../../../stores/useStoreCRMConfig";

export default function Home() {
  const { params, userData } = useContext(SharedDataContext);
  const { activeWorkspace, preferences } = userData || {};
  const { installedCRMIntegrations, activeCRMIntegration, setActiveCRMIntegrationById } =
    useStoreIntegrations();
  // const { isLoading } = useIntegrations(activeWorkspace?.id);

  const { savedCRMConfig, savedCompanyConfig, savedCompanyConfigObj, savedPeopleConfig } =
    useStoreCRMConfig();

  console.log("savedCRMConfig", {
    savedCRMConfig,
    savedCompanyConfig,
    savedCompanyConfigObj,
    savedPeopleConfig,
  });

  const [social, setSocial] = useState([]);
  const [infoData, setInfoData] = useState({});
  const [activeCrmId, setActiveCrmId] = useState("");
  const getProfileData = (social, infoData) => {
    let excludedLinkedIn = [];
    excludedLinkedIn = social && social.length > 0 && social.filter((item) => item?.type !== "LinkedIn");
    setSocial(excludedLinkedIn);
    setInfoData(infoData);
    console.log("infoData in home", infoData);
  };
  useEffect(() => {
    if (params && params.hasCompany !== undefined && params.hasCompany === false) {
      setInfoData(params.infoData ? params.infoData : {});
    }
  }, [params]);

  const [activeTab, setActiveTab] = useState("search_profile");
  const [miniView, setMiniView] = useState(true);
  const isThisCompanyPage = (companyPage) => {
    if (window && typeof window !== "undefined") {
      if (companyPage) {
        window.parent.postMessage("COMPANY_TAB_ACTIVE", "*");
      } else {
        window.parent.postMessage("COMPANY_TAB_INACTIVE", "*");
      }
    }
  };
  useEffect(() => {
    if (!miniView || (params && params.isCompanyPage)) {
      isThisCompanyPage(true);
    } else {
      isThisCompanyPage(false);
    }
  }, [miniView, params]);

  const [crmPhonesEmails, setCRMPhonesEmails] = useState({
    phone_numbers: [],
    email_addresses: [],
  });

  // get crm object configs

  const [crmObjectsConfig, setCRMObjectsConfig] = useState([]);
  const getSavedCRMConfigFn = useMutation("get_saved_crm_object", getSavedCRMConfig, {
    onSuccess(data, variables, context) {
      if (data && data.data && data.data.length > 0) {
        setCRMObjectsConfig(data.data);
      }
    },
  });
  const handleGetSavedCRMConfig = () => {
    let crmObj =
      installedCRMIntegrations &&
      installedCRMIntegrations.length > 0 &&
      installedCRMIntegrations.find((item) => item.id === activeCrmId);
    if (crmObj && crmObj.id) {
      getSavedCRMConfigFn.mutate({
        crmConfigId: crmObj.id,
        crmKey: crmObj?.integration?.key,
        options: {
          headers: { "X-Workspace-Id": activeWorkspace?.id },
        },
      });
    }
  };

  useEffect(() => {
    if (activeWorkspace && activeWorkspace?.id && activeCrmId) {
      setTimeout(() => {
        setActiveCRMIntegrationById(activeCrmId);
      }, 100);
      handleGetSavedCRMConfig();
    }
  }, [activeWorkspace?.id, activeCrmId]);

  const [enrichedTimeline, setEnrichedTimeline] = useState([]);

  const captureEvent = useCaptureEvent();

  return (
    <>
      {params && params.url && params.url.includes("https://www.linkedin.com") && <Header />}
      {(params && params.isCompanyPage) || !miniView ? (
        <div className="p-3">
          {!miniView && !params.isCompanyPage && (
            <button
              onClick={() => {
                setMiniView(true);
                setActiveTab("company_info");
              }}
              className="inline-flex items-center whitespace-nowrap text-xs transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-background border-brand-300 text-brand-700 px-2.5 py-1 justify-between  rounded-[8px] font-semibold mb-4"
            >
              <ChevronLeft width={14} className="mr-0.5" /> <span>Back</span>
            </button>
          )}
          <div className="py-1">
            <CompanyInfo
              companyName={infoData?.company_name}
              miniView={params.isCompanyPage ? false : miniView}
              changeMiniView={(status) => {
                setMiniView(status);
              }}
              crmObjectsConfig={crmObjectsConfig}
              getActiveCRMID={(id) => {
                setActiveCrmId(id);
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <Tabs
            defaultValue={activeTab}
            className="w-full px-3 pt-3 dark:bg-gray-dark-50"
            onValueChange={(value) => {
              setActiveTab(value);
              let eventName = "";
              let eventName2 = "";
              switch (value) {
                case "search_profile":
                  eventName = "tab_switch_profile";
                  eventName2 = "EXP_ProfileTabBtn";
                  break;
                case "company_info":
                  eventName = "tab_switch_company";
                  eventName2 = "EXC_Company_CompanyTabBtn";
                  break;
                case "ai":
                  eventName = "tab_switch_ai";
                  eventName2 = "EXE_Engage_EngageTabBtn";
                  break;
                default:
                  return;
              }

              captureEvent(eventName);
              captureEvent(eventName2);
            }}
          >
            <TabsList className="relative  mb-3 flex w-full justify-center items-center h-min p-1 rounded-[8px] overflow-hidden border border-border bg-gray-50">
              <span
                className="absolute top-1 left-1 h-10 w-[32.5%] bg-brand-600 dark:bg-brand-300 rounded-md transition-transform duration-300 ease-in-out"
                style={{
                  transform: `translateX(${
                    activeTab === "search_profile" ? "0%" : activeTab === "company_info" ? "100%" : "200%"
                  })`,
                }}
              />

              <TabsTrigger
                className={`flex-1 relative z-10 rounded-md px-3 py-2.5 text-sm font-semibold transition-all 
    focus-visible:outline-none shadow-none focus:shadow-none data-[state=active]:shadow-none
    disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-transparent data-[state=active]:text-white
    ${activeTab === "search_profile" ? "text-white" : ""}`}
                value="search_profile"
                onClick={() => setActiveTab("search_profile")}
              >
                Profile
              </TabsTrigger>

              <TabsTrigger
                className={`flex-1 relative z-10 rounded-md px-3 py-2.5 text-sm font-semibold transition-all 
    focus-visible:outline-none  shadow-none focus:shadow-none data-[state=active]:shadow-none
    disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-transparent data-[state=active]:text-white
    ${activeTab === "company_info" ? "text-white" : ""}`}
                value="company_info"
                onClick={() => setActiveTab("company_info")}
              >
                Company
              </TabsTrigger>

              <TabsTrigger
                className={`flex-1 relative z-10 rounded-md px-3 py-2.5 text-sm font-semibold transition-all 
    focus-visible:outline-none   shadow-none focus:shadow-none data-[state=active]:shadow-none
    disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-transparent data-[state=active]:text-white
    ${activeTab === "ai" ? "text-white" : ""}`}
                value="ai"
                onClick={() => setActiveTab("ai")}
              >
                Engage
              </TabsTrigger>
            </TabsList>

            <TabsContent value="search_profile">
              <div className="space-y-3 mb-3">
                <div className="p-4  border border-input  bg-background rounded-[12px]">
                  <ProfileInfo infoData={infoData} social={social} />
                  <CRM
                    activeWorkspace={activeWorkspace}
                    recordData={{
                      name: infoData?.full_name ? infoData?.full_name : infoData?.first_name,
                      first_name: infoData?.first_name,
                      last_name: infoData?.last_name,
                      company: infoData?.company_name,
                      id: infoData.contact_id ? infoData.contact_id : params?.person_id,
                      linkedin_url: params?.url,
                      company_linkedin_url: infoData?.company_linkedin_url,
                      contact_id: infoData.contact_id ? infoData.contact_id : "",
                      person_id: infoData.person_id ? infoData.person_id : "",
                      organization_id: infoData?.organization_id,
                    }}
                    activeCrm={activeCRMIntegration?.id}
                    type="person"
                    getCRMPhonesEmails={(data) => {
                      setCRMPhonesEmails(data);
                    }}
                    crmObjectsConfig={crmObjectsConfig}
                    contactRevealed={enrichedTimeline && enrichedTimeline.length > 0 ? true : false}
                    getActiveCRMID={(id) => {
                      setActiveCrmId(id);
                    }}
                    isCRMBulkSearchPending={false}
                  />
                </div>
              </div>

              <Tabs defaultValue="contact_tab" className="w-full">
                <TabsList className="text-muted-foreground relative mt-3 mb-3 flex w-full justify-center items-center h-min p-1 rounded-[8px] overflow-hidden border border-border bg-gray-50">
                  <TabsTrigger
                    className="group flex-1 rounded-md px-3 py-2 text-sm font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background border border-gray-50 data-[state=active]:border-brand-300 data-[state=active]:text-brand-700 data-[state=active]:shadow-none"
                    value="contact_tab"
                    onClick={() => {
                      captureEvent("EXP_Person_ContactBtn");
                    }}
                  >
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="transition-all stroke-gray-600 group-data-[state=active]:stroke-brand-700"
                    >
                      <path
                        d="M7.65056 7.37779C8.23055 8.58581 9.02121 9.71801 10.0225 10.7193C11.0238 11.7206 12.156 12.5113 13.3641 13.0913C13.468 13.1412 13.5199 13.1661 13.5857 13.1853C13.8193 13.2534 14.1062 13.2045 14.304 13.0628C14.3597 13.0229 14.4073 12.9753 14.5026 12.88C14.7939 12.5887 14.9396 12.443 15.0861 12.3478C15.6385 11.9886 16.3506 11.9886 16.9031 12.3478C17.0495 12.443 17.1952 12.5887 17.4865 12.88L17.6489 13.0424C18.0918 13.4853 18.3132 13.7067 18.4335 13.9446C18.6728 14.4175 18.6728 14.9761 18.4335 15.449C18.3132 15.6869 18.0918 15.9083 17.6489 16.3512L17.5176 16.4825C17.0762 16.9239 16.8555 17.1446 16.5555 17.3131C16.2226 17.5001 15.7055 17.6346 15.3237 17.6334C14.9795 17.6324 14.7444 17.5657 14.274 17.4322C11.7462 16.7147 9.36086 15.361 7.37088 13.371C5.38089 11.381 4.02716 8.99569 3.30969 6.46786C3.17618 5.99749 3.10943 5.7623 3.10841 5.41818C3.10727 5.03633 3.24174 4.51925 3.42875 4.18633C3.59729 3.88631 3.81797 3.66563 4.25932 3.22428L4.39069 3.09292C4.83355 2.65005 5.05499 2.42861 5.29281 2.30833C5.76577 2.0691 6.32433 2.0691 6.7973 2.30832C7.03511 2.42861 7.25655 2.65005 7.69942 3.09291L7.86181 3.25531C8.15315 3.54665 8.29881 3.69231 8.39405 3.8388C8.75321 4.3912 8.75322 5.10336 8.39405 5.65576C8.29881 5.80225 8.15315 5.94791 7.86181 6.23925C7.76655 6.33451 7.71892 6.38214 7.67905 6.43782C7.53737 6.63568 7.48846 6.92256 7.55656 7.15619C7.57572 7.22193 7.60067 7.27389 7.65056 7.37779Z"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </TabsTrigger>
                  {/* <TabsTrigger
                    className="group flex-1 rounded-md px-3 py-2 text-sm font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background border border-gray-50 data-[state=active]:border-brand-300 data-[state=active]:text-brand-700 data-[state=active]:shadow-none"
                    value="highlights_tab"
                    onClick={() => {
                      captureEvent("EXP_Person_HighlightBtn");
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="transition-all stroke-gray-600 group-data-[state=active]:stroke-brand-700"
                    >
                      <path
                        d="M9 11H6.5M13.333 4.83268H6.66634M16.6663 8.74935V5.66602C16.6663 4.26588 16.6663 3.56582 16.3939 3.03104C16.1542 2.56063 15.7717 2.17818 15.3013 1.9385C14.7665 1.66602 14.0665 1.66602 12.6663 1.66602H7.33301C5.93288 1.66602 5.23281 1.66602 4.69803 1.9385C4.22763 2.17818 3.84517 2.56063 3.60549 3.03104C3.33301 3.56582 3.33301 4.26588 3.33301 5.66602V14.3327C3.33301 15.7328 3.33301 16.4329 3.60549 16.9677C3.84517 17.4381 4.22763 17.8205 4.69803 18.0602C5.23281 18.3327 5.93288 18.3327 7.33301 18.3327H9.58301M11.666 8.16602H6.66602"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <g clip-path="url(#clip0_6926_66172)">
                        <path
                          d="M12.5003 18.3327V16.666M12.5003 13.3327V11.666M11.667 12.4993H13.3337M11.667 17.4993H13.3337M15.3337 11.9993L14.7556 13.5023C14.6616 13.7467 14.6146 13.8689 14.5415 13.9717C14.4767 14.0628 14.3971 14.1424 14.306 14.2072C14.2032 14.2803 14.081 14.3273 13.8366 14.4213L12.3337 14.9993L13.8366 15.5774C14.081 15.6714 14.2032 15.7184 14.306 15.7915C14.3971 15.8563 14.4767 15.9359 14.5415 16.027C14.6146 16.1298 14.6616 16.252 14.7556 16.4964L15.3337 17.9993L15.9117 16.4964C16.0057 16.252 16.0527 16.1298 16.1258 16.027C16.1906 15.9359 16.2702 15.8563 16.3613 15.7915C16.4641 15.7184 16.5863 15.6714 16.8307 15.5774L18.3337 14.9993L16.8307 14.4213C16.5863 14.3273 16.4641 14.2803 16.3613 14.2072C16.2702 14.1424 16.1906 14.0628 16.1258 13.9717C16.0527 13.8689 16.0057 13.7467 15.9117 13.5023L15.3337 11.9993Z"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6926_66172">
                          <rect width="8" height="8" fill="white" transform="translate(11 11)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </TabsTrigger> */}
                  <TabsTrigger
                    className="group flex-1 rounded-md px-3 py-2 text-sm font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background border border-gray-50 data-[state=active]:border-brand-300 data-[state=active]:text-brand-700 data-[state=active]:shadow-none"
                    value="persona_tab"
                    onClick={() => {
                      captureEvent("EXP_Person_PersonaBtn");
                    }}
                  >
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="transition-all stroke-gray-600 group-data-[state=active]:stroke-brand-700"
                    >
                      <path
                        d="M13.6676 17.5007V16.5007C13.6676 15.1005 13.6676 14.4005 13.3952 13.8657C13.1555 13.3953 12.773 13.0128 12.3026 12.7731C11.7678 12.5007 11.0678 12.5007 9.66764 12.5007H6.00098C4.60085 12.5007 3.90078 12.5007 3.366 12.7731C2.8956 13.0128 2.51314 13.3953 2.27346 13.8657C2.00098 14.4005 2.00098 15.1005 2.00098 16.5007V17.5007M13.6676 5.00065L15.3343 6.66732L18.6676 3.33398M10.751 6.25065C10.751 7.86148 9.44514 9.16732 7.83431 9.16732C6.22348 9.16732 4.91764 7.86148 4.91764 6.25065C4.91764 4.63982 6.22348 3.33398 7.83431 3.33398C9.44514 3.33398 10.751 4.63982 10.751 6.25065Z"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </TabsTrigger>
                </TabsList>

                <TabsContent value="contact_tab">
                  <div className="pb-3">
                    {userData && userData.id ? (
                      params &&
                      params.hasCompany && (
                        <Contact
                          getProfileData={getProfileData}
                          crmPhonesEmails={crmPhonesEmails}
                          getEnrichedTimeline={(data) => {
                            setEnrichedTimeline(data ? data : []);
                          }}
                        />
                      )
                    ) : (
                      <Skeleton className="h-[125px] w-full rounded-xl" />
                    )}

                    {params && !params.hasCompany && userData && userData.id && <NoCompany />}
                  </div>
                </TabsContent>
                <TabsContent value="persona_tab">
                  {userData && userData.id && (
                    <Persona
                      contact_id={params.contact_id}
                      activeWorkspace={userData.activeWorkspace ? userData.activeWorkspace : {}}
                      userId={userData.id}
                    />
                  )}
                </TabsContent>
                <TabsContent value="highlights_tab">
                  {userData && userData.id && (
                    <Highlights
                      contact_id={params.contact_id}
                      activeWorkspace={userData.activeWorkspace ? userData.activeWorkspace : {}}
                      userId={userData.id}
                    />
                  )}
                </TabsContent>
              </Tabs>
            </TabsContent>
            <TabsContent value="company_info">
              <div className="py-1">
                {params && params.hasCompany && (
                  <CompanyInfo
                    contactLinkedinUrl={params?.url}
                    companyName={infoData?.company_name}
                    miniView={miniView}
                    changeMiniView={(status) => {
                      setMiniView(status);
                    }}
                    crmObjectsConfig={crmObjectsConfig}
                  />
                )}
                {params && !params.hasCompany && <NoCompany />}
              </div>
            </TabsContent>
            <TabsContent value="ai">
              {userData && userData.id && (
                <div>
                  {userData && (userData.job_function === null || userData.job_function === "") && (
                    <Onboarding />
                  )}
                  {userData && userData.job_function !== null && params && (
                    <MessageDrafter
                      activeWorkspace={userData.activeWorkspace ? userData.activeWorkspace : {}}
                      person_id={params?.person_id}
                    />
                  )}
                </div>
              )}
            </TabsContent>
          </Tabs>
        </>
      )}
    </>
  );
}
